import { LinkButton } from '@/components/ui/link-button';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { useIsMobile } from '@/hooks/use-is-mobile';

export const MobileAddToCartSuccessTip = ({
  addToCartQty,
  addToCartStatus,
}: {
  addToCartQty: string;
  addToCartStatus: boolean;
}) => {
  const { isDesktop } = useIsMobile();

  if (isDesktop) {
    return null;
  }

  return (
    <Sheet open={addToCartStatus}>
      <SheetContent
        side={'top'}
        showCloseButton={false}
        className='top-[86px]'
        maskClassName='top-[86px]'
      >
        <p className=' pb-[15px] text-center text-primary'>{addToCartQty} item added to your cart</p>
        <LinkButton
          href='/checkout'
          className='h-[40px] w-full text-white'
        >
          CHECKOUT
        </LinkButton>
      </SheetContent>
    </Sheet>
  );
};
